// Generated by ts-to-zod
import { z } from 'zod'

import { BLOCK_TYPE } from '../../../types/next/enums'

import { ProductRecommendationSource } from './../../../types/next/blocks/productRecommendationsBlock'
import { iBlockSchema, blockBaseSettingsSchema } from './baseBlock.zod'
import { referenceIdSchema } from './ids.zod'
import {
  ctaOptionSchema,
  recurrenceUnitSchema,
  variablePriceReferenceSchema
} from './productsBlock.zod'
import { contextParameterReferenceSchema } from './references.zod'

export const productRecommendationSourceSchema = z.nativeEnum(
  ProductRecommendationSource
)

export const contractReferenceSchema = contextParameterReferenceSchema.extend({
  meaning: z.literal('source')
})

export const productRecommendationsBlockBaseSettingsSchema = z.object({
  ctaOption: ctaOptionSchema,
  showTrailingDecimalZeros: z.boolean(),
  showRecurringTotal: z.boolean(),
  recurrenceUnit: recurrenceUnitSchema.optional(),
  featuresLimit: z.number()
})

export const contractBasedProductRecommendationsBlockSchema =
  iBlockSchema.extend({
    type: z.literal(BLOCK_TYPE.PRODUCT_RECOMMENDATIONS),
    settings: blockBaseSettingsSchema
      .and(productRecommendationsBlockBaseSettingsSchema)
      .and(
        z.object({
          source: z.literal(ProductRecommendationSource.CONTRACT)
        })
      ),
    references: z.record(
      referenceIdSchema,
      z.union([contractReferenceSchema, variablePriceReferenceSchema])
    )
  })

export const entityBasedProductRecommendationsBlockSchema = iBlockSchema.extend(
  {
    type: z.literal(BLOCK_TYPE.PRODUCT_RECOMMENDATIONS),
    settings: blockBaseSettingsSchema
      .and(productRecommendationsBlockBaseSettingsSchema)
      .and(
        z.object({
          source: z.literal(ProductRecommendationSource.RECOMMENDATIONS),
          recommendationIds: z.array(z.string()).optional()
        })
      ),
    references: z.record(referenceIdSchema, variablePriceReferenceSchema)
  }
)

export const productRecommendationsBlockSchema = z.union([
  contractBasedProductRecommendationsBlockSchema,
  entityBasedProductRecommendationsBlockSchema
])

const productTileDataSchema = z.any()

export const productRecommendationsBlockValueSchema = z
  .union([productTileDataSchema, z.array(productTileDataSchema)])
  .nullable()
